import { render, staticRenderFns } from "./CommentText.vue?vue&type=template&id=9c500ef4&"
import script from "./CommentText.vue?vue&type=script&lang=ts&"
export * from "./CommentText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports